import { useNotify, useRecordContext } from 'react-admin'
import { Button } from '@mui/material'
import { usePriceModalContext } from '../../../../Utils/providers/PriceModalProvider'
import { useAdjustmentStatusContext } from '../../../../Utils/providers/AdjustmentStatusProvider'

const GetOffersButton = () => {
  const notify = useNotify()
  const record = useRecordContext()
  const { missingSections, allowGetOffers } = useAdjustmentStatusContext()
  const { openModal } = usePriceModalContext()

  const handleClick = () => {
    const capHistory = record?.leadContact?.vehicle?.vehicleCapHistory ?? []
    const retailValue =
      record?.leadContact?.vehicle?.vehicleSalvage?.retailValue

    const hasCapHistory = capHistory.length > 0
    const hasRetailValue = Boolean(retailValue)

    if (!hasCapHistory && !hasRetailValue) {
      notify(
        'No CAP available. Please enter a retail value before getting an offer',
        { type: 'error' }
      )
      return
    }

    if (!allowGetOffers) {
      const missingItems = [
        missingSections.requiredAdjustments && 'Missing primary adjustments',
        missingSections.secondaryAdjustments && 'Missing secondary adjustments',
        missingSections.faultAdjustments && 'Missing vehicle faults',
        missingSections.vehicleDamage && 'Missing vehicle damage',
      ].filter(Boolean)

      const extraMessage = missingItems.length
        ? '• ' + missingItems.join('• ')
        : ''

      notify(
        `Please complete vehicle checks before getting offers${extraMessage}`,
        { type: 'error' }
      )
      return
    }

    openModal('confirmation')
  }

  return (
    <Button
      fullWidth
      onClick={handleClick}
      sx={{
        borderColor: allowGetOffers ? '' : 'grey.500',
        color: allowGetOffers ? '' : 'grey.500',
        opacity: allowGetOffers ? 1 : 0.5,
      }}
    >
      Get offers
    </Button>
  )
}

export default GetOffersButton
